export default "https://cdn-static.gokick.com/assets/bd7d2df9c3fbba7be4a416b625ad3f88793f3763/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";